import React from 'react';
import { Group, Text, Image, Grid, AppShell } from '@mantine/core';
import bi_logo from '../../assets/logo/bi.svg'
import jku_logo from '../../assets/logo/jku-dark.png'
import vds_logo from '../../assets/logo/vds-dark.png'

const Header = () => {
    return (
        <AppShell.Header style={{ backgroundColor: "#34354a", padding: 12 }}>
            <Grid align='center' style={{ height: "100%" }}>
                <Grid.Col span={3}><Text style={{ fontFamily: 'Source Code Pro, monospace' }} size='xl' c="#f3f3f7" fw={500}>PrimeKG Path Explorer</Text></Grid.Col>
                <Grid.Col span={9}>
                    <Group justify="flex-end">
                        <Image src={jku_logo} style={{ width: "100%", maxWidth: "90px"}} />
                        <Image src={vds_logo} style={{ width: "100%", maxWidth: "90px" }} />
                        <Image src={bi_logo} style={{ width: "100%", maxWidth: "90px" }} />
                    </Group>
                </Grid.Col>
            </Grid>
        </AppShell.Header>
    );
};

export default Header;
